import { useDispatch, useSelector } from 'react-redux';
import { selectLocationBPPLimit, selectLocationBuildingLimit } from '../../../../selectors/application';
import { setEquipmentBreakdownCoverage, setCheckedEndorsement } from '../../../../actions/application';
import { formatCurrency } from '../../../../helpers/formatNumber';
import { EndorsementKey } from '../../types';
import EndorsementSummaryCardLayout from '../../../Summary/Endorsements/EndorsementSummaryCardLayout';

const EquipmentBreakdownSummaryCard = ({ value }: { value: any }) => {
  const dispatch = useDispatch();
  const buildingLimit = useSelector(selectLocationBuildingLimit) || 0;
  const bppLimit = useSelector(selectLocationBPPLimit) || 0;

  const coverageInfo = [{ coverage: 'Equipment Breakdown Limit', limit: formatCurrency(buildingLimit || bppLimit) }];

  const handleRemove = () => {
    dispatch(setCheckedEndorsement(EndorsementKey.EquipmentBreakdownEndorsement, false));
    dispatch(setEquipmentBreakdownCoverage(null));
  };

  const handleRestore = () => {
    dispatch(setCheckedEndorsement(EndorsementKey.EquipmentBreakdownEndorsement, true));
    dispatch(setEquipmentBreakdownCoverage(value));
  };

  return (
    <EndorsementSummaryCardLayout
      label="Equipment Breakdown Coverage"
      coverageInfo={coverageInfo}
      onRemove={handleRemove}
      onRestore={handleRestore}
    />
  );
};

export default EquipmentBreakdownSummaryCard;
